export function getGAClientId(): string {
  const cookie: Record<string, string> = {};
  if (typeof window === "undefined") {
    return '';
  }
  document.cookie.split(';').forEach((el) => {
    const splitCookie = el.split('=');
    const key = splitCookie[0].trim();
    const value = splitCookie[1];
    if (key && value) {
      cookie[key] = value;
    }
  });
  if (cookie["_ga"]) {
    return cookie["_ga"].substring(6);
  }

  return '';
}
